<template lang="pug">
.contacts-listing
	Loader(v-if="!loaded")
	.contacts-listing__error(v-else-if="error") 
		h3 {{ errorText }}
	AppGridContainer(v-else-if="view == 'grid'", :user="user", :district="district")
	AppTableContainer(v-else, :contacts="contacts")
</template>

<script>
import { mapMutations } from "vuex";

import Loader from "../org-search/components/Loader.vue";
import AppTableContainer from "./components/table/TableContainer.vue";
import AppGridContainer from "./components/grid/GridContainer.vue";

export default {
	name: "ContactsListingApp",
  components: {
		Loader,
		AppTableContainer,
		AppGridContainer,
  },
  data() {
    return {
      loaded: false,
			contacts: null,
			user: null,
			district: null,
			view: this.$root.listingDisplay,
			error: false,
			errorText: null,
    };
  },
	methods: {
		...mapMutations([
			"setStateValue"
		]),
		loadContactData(endpoint) {
			const req = new Request(endpoint);
			fetch(req)
				.then(res => {
					if (!res.ok) {
						this.errorText = `There was an error retrieving your contacts. Please try again later. Status: ${res.status}`;
						this.error = true;
						throw new Error(`HTTP error! Status: ${res.status}`);
					} else {
						return res.json();
					}
				})
				.then(data => {
					// console.log(data)
					if (!data.contacts || !data.contacts.contacts || data.contacts.contacts.length == 0) {
						this.errorText = "There were no contacts found.";
						this.error = true;
						this.loaded = true;
						return;
					}
					if (this.$root.listingDisplay == "grid") {
						this.setStateValue(["contactsDisplayList", data.contacts.contacts]);
						this.setStateValue(["contactMasterList", data.contacts.contacts]);
					}
					else this.contacts = data.contacts.contacts;
					this.user = data.user;
					this.district = data.district;
					this.loaded = true;
				});
		},
	},
  created() {
		this.loadContactData(this.$root.endpoint);
  },
};
</script>


<style scoped lang="scss">
.contacts-listing {
	position: relative;
	min-height: 420px;
	&__error {
		text-align: center;
	}
}
</style>